export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8801.f1323805.jpg";